import { Icon } from "@vds/icons";

export const getCommonAppsTableColumns = ({
  showTableFilter,
  filteredInfo,
  appList,
  createSorterForAlertStatus,
  createTableFilterList,
  createTableFilterStaticList,
  GmtToLocal,
}) => [
  {
    title: "Deployment Id",
    dataIndex: "id",
    key: "id",
    width: "25%",
    showCheckBox: false,
  },
  {
    title: "App Name",
    dataIndex: "appName",
    width: "30%",
    key: "appName",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: "30%",
  },
  {
    title: "",
    dataIndex: "Unsubscribe",
    key: "Unsubscribe",
    isDelete: true,
  },
];
